<template>
    <header
        :class="$style.header"
        data-interface-section="desktop-header"
    >
        <div :class="$style.logo_place" />
        <TransitionGroup
            tag="div"
            persisted
            :moveClass="$style.list_move"
            :class="$style.flexible_block"
        >
            <RewardsWidget key="rewards" />
            <template v-if="isUserInfoLoaded">
                <UserWidget
                    v-if="user && isAuthorized"
                    key="user"
                    :user="user"
                    :isProfilePage="isUserProfilePage"
                    :userBalance="userBalance"
                    @logout="logout"
                />
                <Button
                    v-else
                    key="signin"
                    size="xl"
                    interfaceTarget="open-sign-in-modal"
                    @click="signin"
                >
                    {{ $tr('mobileHeader.login') }}
                </Button>
            </template>
            <div
                key="spacer"
                :class="$style.spacer"
            />
        </TransitionGroup>
        <div :class="$style.right_block">
            <HeaderTiles />
        </div>
    </header>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Button from '@/components_new/Button.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'

import HeaderTiles from './components/HeaderTiles.vue'
import RewardsWidget from './components/RewardsWidget.vue'
import UserWidget from './components/UserWidget.vue'

const layoutStore = useLayoutStore()
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
const isUserProfilePage = computed(() => route.name === ROUTE_NAMES.PROFILE)
const { isAuthorized, isUserInfoLoaded, user, userBalance } = storeToRefs(userStore)
async function logout() {
    await userStore.logout()
    router.replace({ name: ROUTE_NAMES.MAIN })
}

function signin() {
    layoutStore.setSignInModalOpened(true)
}
</script>
<style module>
.header {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
}

.spacer {
    flex-grow: 2;
}

.flexible_block {
    display: flex;
    flex-grow: 1;
    align-items: center;
    gap: 4px;
}

.logo_place {
    width: 150px;
    background-color: transparent;
    height: 52px;
}

.right_block {
    margin-left: auto;
}

.list_move {
    transition: all 200ms ease;
}
</style>
